import React, { useState } from "react";
import { Form, Input, Button, Typography, Alert, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../certsweep.png";
import loginIllustration from "../assets/undraw_certification_i2m0.svg";

const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setErrorMsg(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          username: values.username,
          password: values.password,
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        navigate("/dashboard");
      } else {
        setErrorMsg(response.data.message || "Unbekannter Fehler beim Login.");
      }
    } catch (error) {
      const backendMsg = error.response?.data?.message;
      if (error.response?.status === 403) {
        setErrorMsg("Zugriff verweigert: Sie sind nicht berechtigt.");
      } else if (error.response?.status === 401) {
        setErrorMsg("Nicht autorisiert: Benutzername oder Passwort falsch.");
      } else {
        setErrorMsg(backendMsg || "Fehler beim Login.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      }}
    >
      <Row
        style={{
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          borderRadius: "20px",
          overflow: "hidden",
        }}
      >
        {/* Linke Seite – Login */}
        <Col
          xs={24}
          md={12}
          style={{
            backgroundColor: "#eaf3ff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 24px",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 420,
              backgroundColor: "#001529",
              borderRadius: 16,
              padding: 32,
              boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
              transition: "all 0.3s ease",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <img
                src={logo}
                alt="Verinorm"
                style={{
                  height: 50,
                  filter: "brightness(0) invert(1)",
                }}
              />
            </div>

            <Title
              level={3}
              style={{ color: "#ffffff", marginBottom: 8, textAlign: "center" }}
            >
              Willkommen zurück
            </Title>
            <Text
              style={{
                color: "#f0f8ff",
                display: "block",
                textAlign: "center",
                marginBottom: 24,
              }}
            >
              Bitte melde dich mit deinen Zugangsdaten an.
            </Text>

            {errorMsg && (
              <Alert
                message="Login fehlgeschlagen"
                description={errorMsg}
                type="error"
                showIcon
                style={{ marginBottom: 24 }}
              />
            )}

            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item
                label={<span style={{ color: "#ffffff" }}>Benutzername</span>}
                name="username"
                rules={[
                  { required: true, message: "Bitte Benutzername eingeben!" },
                ]}
              >
                <Input
                  placeholder="Benutzername"
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "6px",
                    height: "40px",
                  }}
                />
              </Form.Item>

              <Form.Item
                label={<span style={{ color: "#ffffff" }}>Passwort</span>}
                name="password"
                rules={[
                  { required: true, message: "Bitte Passwort eingeben!" },
                ]}
              >
                <Input.Password
                  placeholder="Passwort"
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "6px",
                    height: "40px",
                  }}
                />
              </Form.Item>

              <Form.Item style={{ marginTop: 32 }}>
                <Button
                  type="default"
                  htmlType="submit"
                  loading={loading}
                  block
                  style={{
                    backgroundColor: "#1890ff",
                    color: "#ffffff",
                    fontWeight: "bold",
                    border: "none",
                    height: "44px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    boxShadow: "0 4px 12px rgba(24, 144, 255, 0.3)",
                    transition: "all 0.3s ease",
                  }}
                  className="login-button"
                >
                  Einloggen
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>

        {/* Rechte Seite – Illustration */}
        <Col
          md={12}
          style={{
            backgroundColor: "#ffffff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 24,
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: 24,
            }}
          >
            <img
              src={loginIllustration}
              alt="Login Illustration"
              style={{ maxWidth: "80%", height: "auto" }}
            />
            <Title
              level={4}
              style={{ marginTop: 32, color: "#001529", textAlign: "center" }}
            >
              Effizientes Zertifikatsmanagement
            </Title>
            <Text style={{ color: "#595959", textAlign: "center" }}>
              Behalten Sie den Überblick über all Ihre Zertifikate und deren
              Ablaufzeiten.
            </Text>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Login;

/* Fügen Sie diese CSS-Styles in Ihre Stylesheet-Datei ein */
/* 

*/
